module.exports = __webpack_public_path__ + "img/ecopayz-hover.ea491dc5.png";